import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import type { PremiumReport } from "../../shared/types";
import { ReportView } from "../components/report/ReportView";
import { getAdminReportPreviewRenderData, getPremiumReportRenderData } from "../lib/testApi";

export function ReportRenderPage() {
  const { reportId, attemptId } = useParams();
  const [searchParams] = useSearchParams();
  const credential = searchParams.get("credential");
  const [report, setReport] = useState<PremiumReport | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if ((!reportId && !attemptId) || !credential) {
      setError("Report render access is not available.");
      return;
    }

    setReport(null);
    setError(null);
    const loadReport = reportId ? getPremiumReportRenderData(reportId, credential) : getAdminReportPreviewRenderData(attemptId as string, credential);
    loadReport
      .then(setReport)
      .catch(() => setError("Report render access is not available."));
  }, [attemptId, credential, reportId]);

  if (error) {
    return (
      <main className="min-h-screen bg-slate-950 px-6 py-12 text-white">
        <div className="mx-auto max-w-xl rounded-2xl border border-white/10 bg-white/10 p-6 text-center">
          <p className="text-sm font-semibold text-slate-200">{error}</p>
        </div>
      </main>
    );
  }

  if (!report) {
    return (
      <main className="min-h-screen bg-slate-950 px-6 py-12 text-white">
        <div className="mx-auto max-w-xl rounded-2xl border border-white/10 bg-white/10 p-6 text-center">
          <p className="text-sm font-semibold text-slate-200">Preparing report...</p>
        </div>
      </main>
    );
  }

  return (
    <>
      <ReportView report={report} showPrintButton={false} mode="pdf" />
      <div
        data-pdf-ready="true"
        aria-hidden="true"
        style={{ position: "fixed", width: 1, height: 1, opacity: 0, pointerEvents: "none", left: 0, top: 0 }}
      />
    </>
  );
}
